export const wallet = {
  en: {
    "wallet.available_balance": "Available balance",
    "wallet.back": "Back to Wallet",
    "wallet.trade": "Trade",
    "wallet.withdrawal": "Withdrawal",
    "wallet.withdrawal_top_balance": "WITHDRAWAL",
    "wallet.withdrawal_history": "Withdrawals",
    "wallet.all_types": "All types",
    "wallet.all_types_history": "All",
    "wallet.deposit": "Deposit",
    "wallet.deposit_top_balance": "DEPOSIT",
    "wallet.deposit_history": "Deposits",
    "wallet.transaction_history": "Transaction History",
    "wallet.transaction_history_top_balance": "HISTORY",
    "wallet.history_table.id": "ID",
    "wallet.history_table.bonus_amount": "Bonus amount",
    "wallet.history_table.bonus_short": "Bonus",
    "wallet.credited_amount": "Credited amount",
    "wallet.destination": "Destination",
    "wallet.hash": "TX Hash",
    "wallet.enter_amount": "Enter the amount USD",
    "wallet.number": "Wallet number",
    "wallet.min_deposit": "Minimum deposit amount",
    "wallet.min_withdraw": "Minimum withdraw amount",
    "wallet.max_amount": "Max amount per transaction",
    "wallet.withdrawal_funds": "Withdrawal funds",
    "wallet.fee": "Fee",
    "wallet.received": "Will be received",
    "wallet.select_currency": "Select currency",
    "wallet.status": "Status",

    "wallet.cryptocurrencies": "Cryptocurrencies",

    "wallet.confirm_withdrawal": "Confirm withdrawal",
    "wallet.confirm_withdrawal_text": "Confirm this action to withdrawal",
    "wallet.currency": "Currency",
    "wallet.platform_fee": "Platform Fee",
    "wallet.will_be_withdrawn": "Will be withdrawn",
    "wallet.enter_2fa": "Enter the 2FA 6-digit Code",
    "wallet.digit": "6-digit Code",
    "wallet.warningDemo":
      "You are using a Demo account, it is not possible to withdraw/deposit money, do you want to switch to the Real account?",
    "wallet.warningText":
      "Withdrawal process becomes available after you deposit on your account. Typically, a withdrawal request is processed automatically and takes a few minutes, and in some cases up to 3 business days.",
    "wallet.free_balance": "Free balance:",
    "wallet.minimum_withdrawal_amount": "Minimum withdrawal amount:",
    "wallet.commission": "Commission:",
    "wallet.method": "Method:",
    "wallet.warningUnverified":
      "You will not be able to withdraw money until you complete the verification process.",
    "wallet.send2FA": "Send 2FA code",
    "wallet.deposit_popup1": "The deposit in the amount of",
    "wallet.deposit_popup2": "was successful",
    "wallet.deposit_popup3": "was failed",
    "wallet.deposit_type": "Deposit",
    "wallet.withdraw_type": "Withdraw",
    "wallet.no_limits": "no limits",

    "wallet.from": "From",
    "wallet.to": "to",
    "wallet.date_range_selected": "Selected",
    "wallet.date_range_filter": "Date range",
    "wallet.transfer": "Transfer",
    "wallet.top_up": "Top up",

    "wallet.deposit.country_region": "Your country/Region",
    "wallet.deposit.search": "Search",
    "wallet.deposit.minimum_deposit_amount": "Minimum deposit amount:",
    "wallet.deposit.quick_withdrawal": "Quick and easy withdrawal",
    "wallet.deposit.minimum_withdrawal_amount": "Minimum withdrawal amount:",
    "wallet.deposit.no_commission": "No commission",
    "wallet.deposit.popular": "Popular",
    "wallet.deposit.cards": "Cards",
    "wallet.deposit.visa_mastercard": "Visa, Mastercard (USD)",
    "wallet.deposit.binance_pay": "Binance Pay",
    "wallet.deposit.tether_trc20": "Tether (USDT) TRC-20",
    "wallet.deposit.paypal": "PayPal",
    "wallet.deposit.tron": "Tron (TRX)",
    "wallet.deposit.usdc": "USD Coin (USDC)",

    "wallet.deposit.amount": "Amount",
    "wallet.base_network_usdc_address": "Base Network USDC address:",
    "wallet.continue": "Continue",
    "wallet.finish": "Finish",
    "wallet.payment_method": "Payment Method",
    "wallet.amount_below_minimum":
      "Amount cannot be less than the minimum withdrawal amount ({min})",
    "wallet.amount_exceeds_available_balance":
      "Amount exceeds available balance",

    "wallet.deposit.amount_required": "Please enter deposit amount",
    "wallet.deposit.minimum_deposit_amount_is": "Minimum deposit amount is",

    "wallet.deposit.payment_received": "Payment received!",
    "wallet.deposit.payment_successfully_processed":
      "Your deposit has been successfully processed.",
    "wallet.deposit.deposit_amount": "Deposit amount",
    "wallet.deposit.processing_time": "Processing time",
    "wallet.deposit.transaction_details": "Transaction Details",
    "wallet.deposit.transaction_id": "Transaction ID",
    "wallet.deposit.network": "Network",
    "wallet.deposit.status": "Status",
    "wallet.deposit.date_time": "Date & Time",
    "wallet.deposit.go_to_wallet": "Go to Wallet",
    "wallet.deposit.go_to_trading": "Go to Trading",

    "wallet.deposit.send": "Send",
    "wallet.deposit.using": "using",
    "wallet.deposit.network_word": "network",
    "wallet.deposit.important": "Important",
    "wallet.deposit.use_only_the": "Use only the",
    "wallet.deposit.network_for_transfer": "network for this transfer.",
    "wallet.deposit.failure_to_meet_requirement":
      "Failure to meet this requirement will result in the loss of funds.",
    "wallet.deposit.amount_to_transfer": "Amount to transfer",
    "wallet.deposit.send_to_this": "Send to this",
    "wallet.deposit.address": "address",
    "wallet.deposit.funds_credited_after_confirmations":
      "Your funds will be credited after the required confirmations.",
    "wallet.deposit.payment_summary": "Payment Summary",
    "wallet.deposit.you_will_receive": "You will receive",
    "wallet.deposit.network_label": "Network:",
    "wallet.deposit.processing_time_label": "Processing time:",
    "wallet.deposit.scan_to_pay": "Scan to pay",
    "wallet.deposit.qr_unavailable": "QR unavailable",

    "wallet.deposit.copied": "Copied!",
    "wallet.deposit.no_payment_methods_found": "No payment methods found",
    "wallet.deposit.success": "Success",
    "wallet.deposit.instant": "Instant",
  },

  ru: {
    "wallet.available_balance": "Доступный баланс",
    "wallet.back": "Вернуться в Кошелек",
    "wallet.trade": "Торговля",
    "wallet.withdrawal": "Вывести средства",
    "wallet.withdrawal_top_balance": "ВЫВОД СРЕДСТВ",
    "wallet.withdrawal_history": "Вывод средств",
    "wallet.all_types": "Все типы",
    "wallet.all_types_history": "Все",
    "wallet.deposit": "Внести средства",
    "wallet.deposit_top_balance": "ПОПОЛНЕНИЕ",
    "wallet.deposit_history": "Пополнения",
    "wallet.transaction_history": "История транзакций",
    "wallet.transaction_history_top_balance": "ИСТОРИЯ",
    "wallet.history_table.id": "ID",
    "wallet.history_table.bonus_amount": "Бонусная сумма",
    "wallet.history_table.bonus_short": "Бонус",
    "wallet.credited_amount": "Зачисленная сумма",
    "wallet.destination": "Адрес",
    "wallet.hash": "Хэш транзакции",
    "wallet.enter_amount": "Укажите сумму в USD",
    "wallet.number": "Адрес кошелька",
    "wallet.min_deposit": "Мин. сумма депозита",
    "wallet.min_withdraw": "Мин. сумма вывода",
    "wallet.max_amount": "Макc. сумма за транзакцию",
    "wallet.withdrawal_funds": "Вывести средства",
    "wallet.fee": "Комиссия",
    "wallet.received": "Вы получите",
    "wallet.select_currency": "Выберите валюту",
    "wallet.status": "Статус",
    "wallet.no_limits": "безлимит",

    "wallet.cryptocurrencies": "Криптовалюты",

    "wallet.confirm_withdrawal": "Подтвердить вывод",
    "wallet.confirm_withdrawal_text":
      "Подтвердите данное действие для вывода средств",
    "wallet.currency": "Валюта",
    "wallet.platform_fee": "Комиссия платформы",
    "wallet.will_be_withdrawn": "Будет выведено",
    "wallet.enter_2fa": "Введите 6-значный код 2FA",
    "wallet.digit": "6-значный код",
    "wallet.warningDemo":
      "Вы используете демо-счет, вывести/внести деньги невозможно. Хотите перейти на реальный счет?",
    "wallet.warningText":
      "Процесс вывода становится доступным после того, как вы внесете средства на свой счет. Обычно запрос на вывод обрабатывается автоматически и занимает несколько минут, а в некоторых случаях до 3 рабочих дней.",
    "wallet.free_balance": "Свободный баланс:",
    "wallet.minimum_withdrawal_amount": "Минимальная сумма вывода:",
    "wallet.commission": "Комиссия:",
    "wallet.method": "Метод:",
    "wallet.warningUnverified":
      "Вы не сможете вывести средства до завершения процедуры верификации.",
    "wallet.send2FA": "Отправить код 2FA",
    "wallet.deposit_popup1": "Депозит в размере",
    "wallet.deposit_popup2": "был успешным",
    "wallet.deposit_popup3": "был неудачным",
    "wallet.deposit_type": "Пополнение",
    "wallet.withdraw_type": "Вывод",

    "wallet.from": "От",
    "wallet.to": "до",
    "wallet.date_range_selected": "Выбрано",
    "wallet.date_range_filter": "Период",
    "wallet.transfer": "Передача",
    "wallet.top_up": "Пополнить",

    "wallet.deposit.country_region": "Ваша страна/Регион",
    "wallet.deposit.search": "Поиск",
    "wallet.deposit.minimum_deposit_amount": "Минимальная сумма депозита:",
    "wallet.deposit.quick_withdrawal": "Быстрый и легкий вывод",
    "wallet.deposit.minimum_withdrawal_amount": "Минимальная сумма вывода:",
    "wallet.deposit.no_commission": "Без комиссии",
    "wallet.deposit.popular": "Популярные",
    "wallet.deposit.cards": "Карты",
    "wallet.deposit.visa_mastercard": "Visa, Mastercard (USD)",
    "wallet.deposit.binance_pay": "Binance Pay",
    "wallet.deposit.tether_trc20": "Tether (USDT) TRC-20",
    "wallet.deposit.paypal": "PayPal",
    "wallet.deposit.tron": "Tron (TRX)",
    "wallet.deposit.usdc": "USD Coin (USDC)",

    "wallet.deposit.amount": "Сумма",
    "wallet.base_network_usdc_address": "Адрес USDC в сети Base:",
    "wallet.continue": "Продолжить",
    "wallet.finish": "Завершить",
    "wallet.payment_method": "Метод оплаты",
    "wallet.amount_below_minimum":
      "Сумма не может быть меньше минимальной суммы вывода ({min})",
    "wallet.amount_exceeds_available_balance":
      "Сумма превышает доступный баланс",

    "wallet.deposit.amount_required": "Введите сумму депозита",
    "wallet.deposit.minimum_deposit_amount_is": "Минимальная сумма депозита",

    "wallet.deposit.payment_received": "Платеж получен!",
    "wallet.deposit.payment_successfully_processed":
      "Ваш депозит был успешно обработан.",
    "wallet.deposit.deposit_amount": "Сумма депозита",
    "wallet.deposit.processing_time": "Время обработки",
    "wallet.deposit.transaction_details": "Детали транзакции",
    "wallet.deposit.transaction_id": "ID транзакции",
    "wallet.deposit.network": "Сеть",
    "wallet.deposit.status": "Статус",
    "wallet.deposit.date_time": "Дата и время",
    "wallet.deposit.go_to_wallet": "Перейти в кошелек",
    "wallet.deposit.go_to_trading": "Перейти к торговле",

    "wallet.deposit.send": "Отправить",
    "wallet.deposit.using": "используя",
    "wallet.deposit.network_word": "сеть",
    "wallet.deposit.important": "Важно",
    "wallet.deposit.use_only_the": "Используйте только",
    "wallet.deposit.network_for_transfer": "сеть для этого перевода.",
    "wallet.deposit.failure_to_meet_requirement":
      "Несоблюдение этого требования приведет к потере средств.",
    "wallet.deposit.amount_to_transfer": "Сумма для перевода",
    "wallet.deposit.send_to_this": "Отправить на этот",
    "wallet.deposit.address": "адрес",
    "wallet.deposit.funds_credited_after_confirmations":
      "Ваши средства будут зачислены после необходимого количества подтверждений.",
    "wallet.deposit.payment_summary": "Сводка платежа",
    "wallet.deposit.you_will_receive": "Вы получите",
    "wallet.deposit.network_label": "Сеть:",
    "wallet.deposit.processing_time_label": "Время обработки:",
    "wallet.deposit.scan_to_pay": "Сканируйте для оплаты",
    "wallet.deposit.qr_unavailable": "QR-код недоступен",

    "wallet.deposit.copied": "Скопировано!",
    "wallet.deposit.no_payment_methods_found": "Платёжные методы не найдены",
    "wallet.deposit.success": "Успешно",
    "wallet.deposit.instant": "Мгновенно",
  },

  es: {
    "wallet.available_balance": "Saldo disponible",
    "wallet.back": "Volver a la cartera",
    "wallet.trade": "Operar",
    "wallet.withdrawal": "Retiro",
    "wallet.withdrawal_top_balance": "RETIRO",
    "wallet.withdrawal_history": "Retiros",
    "wallet.all_types": "Todos los tipos",
    "wallet.all_types_history": "Todos",
    "wallet.deposit": "Depósito",
    "wallet.deposit_top_balance": "DEPÓSITO",
    "wallet.deposit_history": "Depósitos",
    "wallet.transaction_history": "Historial de transacciones",
    "wallet.transaction_history_top_balance": "HISTORIAL",
    "wallet.history_table.id": "ID",
    "wallet.history_table.bonus_amount": "Importe del bono",
    "wallet.history_table.bonus_short": "Bono",
    "wallet.credited_amount": "Cantidad acreditada",
    "wallet.destination": "Destino",
    "wallet.hash": "Hash TX",
    "wallet.enter_amount": "Ingresa la cantidad en USD",
    "wallet.number": "Número de billetera",
    "wallet.min_deposit": "Cantidad mínima de depósito",
    "wallet.min_withdraw": "Cantidad mínima de retiro",
    "wallet.max_amount": "Cantidad máxima por transacción",
    "wallet.withdrawal_funds": "Retirar fondos",
    "wallet.fee": "Tarifa",
    "wallet.received": "Se recibirá",
    "wallet.select_currency": "Seleccionar moneda",
    "wallet.status": "Estado",

    "wallet.cryptocurrencies": "Criptomonedas",

    "wallet.confirm_withdrawal": "Confirmar retiro",
    "wallet.confirm_withdrawal_text": "Confirma esta acción para retirar",
    "wallet.currency": "Moneda",
    "wallet.platform_fee": "Tarifa de plataforma",
    "wallet.will_be_withdrawn": "Será retirado",
    "wallet.enter_2fa": "Ingresa el código de 2FA de 6 dígitos",
    "wallet.digit": "Código de 6 dígitos",
    "wallet.warningDemo":
      "Estás usando una cuenta de Demo, no es posible retirar/depositar dinero, ¿quieres cambiar a una cuenta Real?",
    "wallet.warningText":
      "El proceso de retiro estará disponible después de que deposites en tu cuenta. Normalmente, una solicitud de retiro se procesa automáticamente y toma unos minutos, y en algunos casos hasta 3 días hábiles.",
    "wallet.free_balance": "Saldo libre:",
    "wallet.minimum_withdrawal_amount": "Monto mínimo de retiro:",
    "wallet.commission": "Comisión:",
    "wallet.method": "Método:",
    "wallet.warningUnverified":
      "No podrás retirar dinero hasta que completes el proceso de verificación.",
    "wallet.send2FA": "Enviar código 2FA",
    "wallet.deposit_popup1": "El depósito por un monto de",
    "wallet.deposit_popup2": "fue exitoso",
    "wallet.deposit_popup3": "falló",
    "wallet.deposit_type": "Depósito",
    "wallet.withdraw_type": "Retiro",
    "wallet.no_limits": "sin límites",

    "wallet.from": "De",
    "wallet.to": "a",
    "wallet.date_range_selected": "Seleccionado",
    "wallet.date_range_filter": "Rango de fechas",
    "wallet.transfer": "Transferir",
    "wallet.top_up": "Recargar",

    "wallet.deposit.country_region": "Tu país/Región",
    "wallet.deposit.search": "Buscar",
    "wallet.deposit.minimum_deposit_amount": "Monto mínimo de depósito:",
    "wallet.deposit.quick_withdrawal": "Retiro rápido y fácil",
    "wallet.deposit.minimum_withdrawal_amount": "Monto mínimo de retiro:",
    "wallet.deposit.no_commission": "Sin comisión",
    "wallet.deposit.popular": "Popular",
    "wallet.deposit.cards": "Tarjetas",
    "wallet.deposit.visa_mastercard": "Visa, Mastercard (USD)",
    "wallet.deposit.binance_pay": "Binance Pay",
    "wallet.deposit.tether_trc20": "Tether (USDT) TRC-20",
    "wallet.deposit.paypal": "PayPal",
    "wallet.deposit.tron": "Tron (TRX)",
    "wallet.deposit.usdc": "USD Coin (USDC)",

    "wallet.deposit.amount": "Cantidad",
    "wallet.base_network_usdc_address": "Dirección USDC en la red Base:",
    "wallet.continue": "Continuar",
    "wallet.finish": "Finalizar",
    "wallet.payment_method": "Método de pago",
    "wallet.amount_below_minimum":
      "El monto no puede ser menor que el monto mínimo de retiro ({min})",
    "wallet.amount_exceeds_available_balance":
      "El monto supera el saldo disponible",

    "wallet.deposit.amount_required": "Ingresa el monto del depósito",
    "wallet.deposit.minimum_deposit_amount_is":
      "El monto mínimo de depósito es",

    "wallet.deposit.payment_received": "¡Pago recibido!",
    "wallet.deposit.payment_successfully_processed":
      "Tu depósito se ha procesado correctamente.",
    "wallet.deposit.deposit_amount": "Monto del depósito",
    "wallet.deposit.processing_time": "Tiempo de procesamiento",
    "wallet.deposit.transaction_details": "Detalles de la transacción",
    "wallet.deposit.transaction_id": "ID de transacción",
    "wallet.deposit.network": "Red",
    "wallet.deposit.status": "Estado",
    "wallet.deposit.date_time": "Fecha y hora",
    "wallet.deposit.go_to_wallet": "Ir a la billetera",
    "wallet.deposit.go_to_trading": "Ir a operar",

    "wallet.deposit.send": "Enviar",
    "wallet.deposit.using": "usando",
    "wallet.deposit.network_word": "red",
    "wallet.deposit.important": "Importante",
    "wallet.deposit.use_only_the": "Utilice únicamente la",
    "wallet.deposit.network_for_transfer": "red para esta transferencia.",
    "wallet.deposit.failure_to_meet_requirement":
      "El incumplimiento de este requisito provocará la pérdida de los fondos.",
    "wallet.deposit.amount_to_transfer": "Cantidad a transferir",
    "wallet.deposit.send_to_this": "Enviar a esta",
    "wallet.deposit.address": "dirección",
    "wallet.deposit.funds_credited_after_confirmations":
      "Sus fondos serán acreditados después de las confirmaciones requeridas.",
    "wallet.deposit.payment_summary": "Resumen del pago",
    "wallet.deposit.you_will_receive": "Recibirá",
    "wallet.deposit.network_label": "Red:",
    "wallet.deposit.processing_time_label": "Tiempo de procesamiento:",
    "wallet.deposit.scan_to_pay": "Escanee para pagar",
    "wallet.deposit.qr_unavailable": "QR no disponible",

    "wallet.deposit.copied": "¡Copiado!",
    "wallet.deposit.no_payment_methods_found":
      "No se encontraron métodos de pago",
    "wallet.deposit.success": "Completado",
    "wallet.deposit.instant": "Instantáneo",
  },

  ua: {
    "wallet.available_balance": "Доступний баланс",
    "wallet.back": "Назад до гаманця",
    "wallet.trade": "Торгівля",
    "wallet.withdrawal": "Виведення",
    "wallet.withdrawal_top_balance": "ВИВЕДЕННЯ КОШТІВ",
    "wallet.withdrawal_history": "Виведення коштів",
    "wallet.all_types": "Всі типи",
    "wallet.all_types_history": "Усі типи",
    "wallet.deposit": "Депозит",
    "wallet.deposit_top_balance": "ПОПОВНИТИ",
    "wallet.deposit_history": "Поповнення",
    "wallet.transaction_history": "Історія транзакцій",
    "wallet.transaction_history_top_balance": "ІСТОРІЯ",
    "wallet.history_table.id": "ID",
    "wallet.history_table.bonus_amount": "Сума бонусу",
    "wallet.history_table.bonus_short": "Бонус",
    "wallet.credited_amount": "Зарахована сума",
    "wallet.destination": "Отримувач",
    "wallet.hash": "TX Hash",
    "wallet.enter_amount": "Введіть суму (USD)",
    "wallet.number": "Номер гаманця",
    "wallet.min_deposit": "Мінімальна сума депозиту",
    "wallet.min_withdraw": "Мінімальна сума виведення",
    "wallet.max_amount": "Максимальна сума за транзакцію",
    "wallet.withdrawal_funds": "Виведення коштів",
    "wallet.fee": "Комісія",
    "wallet.received": "Отримаєте",
    "wallet.select_currency": "Оберіть валюту",
    "wallet.status": "Статус",

    "wallet.cryptocurrencies": "Криптовалюти",

    "wallet.confirm_withdrawal": "Підтвердити виведення",
    "wallet.confirm_withdrawal_text": "Підтвердіть цю дію для виведення",
    "wallet.currency": "Валюта",
    "wallet.platform_fee": "Комісія платформи",
    "wallet.will_be_withdrawn": "Будуть виведені",
    "wallet.enter_2fa": "Введіть 6-значний код 2FA",
    "wallet.digit": "6-значний код",
    "wallet.warningDemo":
      "Ви використовуєте демо-рахунок, вивести чи внести гроші неможливо. Бажаєте перейти на реальний рахунок?",
    "wallet.warningText":
      "Процес виведення стає доступним після того, як ви внесете кошти на свій рахунок. Зазвичай запит на виведення обробляється автоматично і займає кілька хвилин, а в деяких випадках до 3 робочих днів.",
    "wallet.free_balance": "Вільний баланс:",
    "wallet.minimum_withdrawal_amount": "Мінімальна сума виведення:",
    "wallet.commission": "Комісія:",
    "wallet.method": "Метод:",
    "wallet.warningUnverified":
      "Ви не зможете вивести кошти, поки не пройдете процес верифікації.",
    "wallet.send2FA": "Надіслати код 2FA",
    "wallet.deposit_popup1": "Депозит на суму",
    "wallet.deposit_popup2": "був успішним",
    "wallet.deposit_popup3": "не вдалося",
    "wallet.deposit_type": "Депозит",
    "wallet.withdraw_type": "Виведення",
    "wallet.no_limits": "без обмежень",

    "wallet.from": "Від",
    "wallet.to": "до",
    "wallet.date_range_selected": "Обрано",
    "wallet.date_range_filter": "Період",
    "wallet.transfer": "Переказ",
    "wallet.top_up": "Поповнити",

    "wallet.deposit.country_region": "Ваша країна/Регіон",
    "wallet.deposit.search": "Пошук",
    "wallet.deposit.minimum_deposit_amount": "Мінімальна сума депозиту:",
    "wallet.deposit.quick_withdrawal": "Швидкий і легкий вивід",
    "wallet.deposit.minimum_withdrawal_amount": "Мінімальна сума виведення:",
    "wallet.deposit.no_commission": "Без комісії",
    "wallet.deposit.popular": "Популярні",
    "wallet.deposit.cards": "Картки",
    "wallet.deposit.visa_mastercard": "Visa, Mastercard (USD)",
    "wallet.deposit.binance_pay": "Binance Pay",
    "wallet.deposit.tether_trc20": "Tether (USDT) TRC-20",
    "wallet.deposit.paypal": "PayPal",
    "wallet.deposit.tron": "Tron (TRX)",
    "wallet.deposit.usdc": "USD Coin (USDC)",

    "wallet.deposit.amount": "Сума",
    "wallet.base_network_usdc_address": "Адреса USDC у мережі Base:",
    "wallet.continue": "Продовжити",
    "wallet.finish": "Завершити",
    "wallet.payment_method": "Метод оплати",
    "wallet.amount_below_minimum":
      "Сума не може бути меншою за мінімальну суму виведення ({min})",
    "wallet.amount_exceeds_available_balance":
      "Сума перевищує доступний баланс",

    "wallet.deposit.amount_required": "Введіть суму депозиту",
    "wallet.deposit.minimum_deposit_amount_is": "Мінімальна сума депозиту",

    "wallet.deposit.payment_received": "Платіж отримано!",
    "wallet.deposit.payment_successfully_processed":
      "Ваш депозит успішно оброблено.",
    "wallet.deposit.deposit_amount": "Сума депозиту",
    "wallet.deposit.processing_time": "Час обробки",
    "wallet.deposit.transaction_details": "Деталі транзакції",
    "wallet.deposit.transaction_id": "ID транзакції",
    "wallet.deposit.network": "Мережа",
    "wallet.deposit.status": "Статус",
    "wallet.deposit.date_time": "Дата й час",
    "wallet.deposit.go_to_wallet": "Перейти до гаманця",
    "wallet.deposit.go_to_trading": "Перейти до торгівлі",

    "wallet.deposit.send": "Надіслати",
    "wallet.deposit.using": "використовуючи",
    "wallet.deposit.network_word": "мережу",
    "wallet.deposit.important": "Важливо",
    "wallet.deposit.use_only_the": "Використовуйте лише",
    "wallet.deposit.network_for_transfer": "мережу для цього переказу.",
    "wallet.deposit.failure_to_meet_requirement":
      "Недотримання цієї вимоги призведе до втрати коштів.",
    "wallet.deposit.amount_to_transfer": "Сума для переказу",
    "wallet.deposit.send_to_this": "Надіслати на цю",
    "wallet.deposit.address": "адресу",
    "wallet.deposit.funds_credited_after_confirmations":
      "Ваші кошти будуть зараховані після необхідної кількості підтверджень.",
    "wallet.deposit.payment_summary": "Підсумок платежу",
    "wallet.deposit.you_will_receive": "Ви отримаєте",
    "wallet.deposit.network_label": "Мережа:",
    "wallet.deposit.processing_time_label": "Час обробки:",
    "wallet.deposit.scan_to_pay": "Скануйте для оплати",
    "wallet.deposit.qr_unavailable": "QR-код недоступний",

    "wallet.deposit.copied": "Скопійовано!",
    "wallet.deposit.no_payment_methods_found": "Платіжні методи не знайдено",
    "wallet.deposit.success": "Успішно",
    "wallet.deposit.instant": "Миттєво",
  },
};

export default wallet;
